/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';

// input selectors ...
const selectGridColumnState        = ({groups: {grid}}) => grid?.columnState;
const selectAdd                    = ({groups: {add}}) => add;
const selectAddResult              = state => selectAdd(state).result;
const selectEdit                   = ({groups: {edit}}) => edit;
const selectEditResult             = state => selectEdit(state).result;
const selectEditShowDialog         = state => selectEdit(state).isEditing;
const selectDestroy                = ({groups: {destroy}}) => destroy;
const selectDestroyResult          = state => selectDestroy(state).result;
const selectModularSearch          = ({groups: {search}}) => search;
const selectView                   = ({groups: {view}}) => view;
const selectViewShowDialog         = state => selectView(state).isEditing;
const selectAudit                  = ({groups: {audit}}) => audit;
const selectAuditShowDialog        = state => selectAudit(state).isEditing;
const selectAuditSelected          = state => selectAudit(state).selected;
const selectAuditRecord            = state => selectAudit(state).auditRecord;
const selectAuditShowChangesDialog = state => selectAudit(state).showChangesDialog;
const selectGroup                  = ({groups: {edit}}) => edit.selected;
const accountsMap                  = ({initialization:{accountsMap}}) => accountsMap;

// output selectors ...
export const groupsGridColumnStateSelector = createDeepEqualSelector(selectGridColumnState,
  columnState => columnState
);

export const groupsAddResultSelector = createDeepEqualSelector(selectAddResult,
  result => result
);

export const groupsEditResultSelector = createDeepEqualSelector(selectEditResult,
  result => result
);

export const groupsDestroyResultSelector = createDeepEqualSelector(selectDestroyResult,
  result => result
);

export const groupsModularSearchSelector = createDeepEqualSelector(selectModularSearch,
  search => search
);

export const groupViewShowDialogSelector = createSelector(selectViewShowDialog,
  (isEditing: boolean) => isEditing
);

export const groupEditShowDialogSelector = createSelector(selectEditShowDialog,
  (isEditing: boolean) => isEditing
);
export const groupAuditShowDialogSelector = createSelector(selectAuditShowDialog,
  (isEditing: boolean) => isEditing
);
export const groupAuditSelectedSelector = createDeepEqualSelector(selectAuditSelected,
  selected => selected
);
export const groupAuditRecordSelector = createDeepEqualSelector(selectAuditRecord,
  auditRecord => auditRecord
);
export const groupAuditShowChangesDialogSelector = createSelector(selectAuditShowChangesDialog,
  (showChangesDialog: boolean) => showChangesDialog
);

export const groupSelector = createDeepEqualSelector(selectGroup,
  (account) => account
);

export const accountsMapSelector = createDeepEqualSelector(accountsMap,
  (accountMap) => accountMap);
